import { useMemo } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../hooks/useProfiler";
import useRouteName from "../../../../../hooks/useRouteName";

export function useFranceTaxController() {
  const i18n = useI18n();
  const routename = useRouteName();
  const { isPointOfSale } = useProfiler();

  const canRender = useMemo(() => {
    if (!isPointOfSale("fr")) return false;
    if (routename !== "checkout-payment") return false;
    return true;
  }, [routename, isPointOfSale]);

  const text = useMemo(() => {
    return i18n.trans(t("flights_tax_refund_disclaimer_terms"));
  }, [i18n]);

  return { canRender, text };
}
